module.exports = __webpack_public_path__ + "img/recycled-paper_1.5c2065ad.png";